import { BaseDTO } from "./basedto";

/**
* TMS-15771 Add methods/endpoint to return 3 appsettings values
* (Parent TMS-14954 Due date management logic implementation)
* get appsettings for proposal due date extension
*/
export class DueDateExtensionAppSettingsDTO {
    MaxDaysDueDateExtension: number;
    MaxNoOfTimesDueDateExtension: number;
    MaxOffsetDaysForDueDateExtension: number;

    constructor() {
    }
}

